export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing"
  },
  session: {
    invalidToken: "invalidToken"
  },
  firstTime: {
    succeed: "succeed",
    failed: "failed",
    newUsernameRequired: "newUsernameRequired",
    newPasswordRequired: "newPasswordRequired",
    securityTagRequired: "securityTagRequired",
    securityCodeRequired: "securityCodeRequired"
  },
  updatePassword: {
    succeed: "updatePasswordSucceed",
    failed: "updatePasswordFailed",
    passwordRequired: "passwordRequired",
    newPasswordRequired: "newPasswordRequired"
  },
  security: {
    succeed: "succeed",
    failed: "failed",
    profileIdRequired: "profileIdRequired",
    securityCodeRequired: "securityCodeRequired"
  },
  getAgentDetail: {
    succeed: "succeed",
    failed: "failed"
  },
  getSubDetail: {
    succeed: "succeed",
    failed: "failed"
  },
  session: {
    invalidToken: "invalid_token",
    expired: "session_expired",
    invalidSession: "invalid_session"
  },
  getPGProviderBalance: {
    succeed: "succeed",
    failed: "failed"
  },
};
